module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_30.a7c15bc6.png";